import * as React from "react";
const IconCool3 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M34.5 25.8c0 1.8 1.1 3.3 2.4 3.3h10c1.4 0 2.6-1.4 2.6-3.1v-7.8c0-.9-.6-1.5-1.3-1.5H15.8c-.7 0-1.3.7-1.3 1.5V26c0 1.7 1.2 3.1 2.6 3.1h9.5c1.3 0 2.8-1.5 2.8-3.3v-4.2h5v4.2zM51.4 35.6c-.5-.1-1.1.2-1.2.8-1.6 7.9-8.7 13.7-16.8 13.7-.6 0-1 .4-1 1s.4 1 1 1c9.1 0 16.9-6.4 18.7-15.3.2-.5-.2-1.1-.7-1.2" />
    <path d="M32 2C15.5 2 2 15.5 2 32s13.5 30 30 30 30-13.5 30-30S48.5 2 32 2m0 58C16.6 60 4 47.4 4 32S16.6 4 32 4s28 12.6 28 28-12.6 28-28 28" />
  </svg>
);
export default IconCool3;
